// 上传图片模块
import { uploaded } from '../http'; // 导入http中创建的axios实例
export const upload = {
    uploadFile(params) {
        return uploaded(`${process.env.VUE_APP_BASE_API}/oss/uploadSmallFile`, params);
    },
    uploadVideo(params) {
        return uploaded(`${process.env.VUE_APP_BASE_API}/oss/uploadFile`, params);
    }
}
